import { NavLink, useLocation } from 'react-router-dom';
import { cn } from '../ui-x';
import { isNavItemActive } from './navItems';

/**
 * One labelled nav group on the navy client rail (reference: client.tsx).
 * Rendered by the desktop rail and by the mobile drawer, which shares the
 * rail's navy register.
 */
const MenuItems = ({ label, items, badge, collapsed, onNavigate, className }) => {
  const location = useLocation();

  return (
    <div className={className}>
      {label && !collapsed && (
        <div className='flex items-center justify-between px-3 pb-2'>
          <span className='text-[10px] font-semibold uppercase tracking-wider text-white/40'>
            {label}
          </span>
          {badge && (
            <span className='rounded bg-brand-orange/20 px-1.5 py-0.5 text-[9px] font-bold tracking-wider text-brand-orange'>
              {badge}
            </span>
          )}
        </div>
      )}

      <div className='space-y-1'>
        {items.map((item) => {
          const Icon = item.icon;
          const active = isNavItemActive(item, location.pathname);

          return (
            <NavLink
              key={item.key}
              to={item.path}
              onClick={onNavigate}
              title={collapsed ? item.label : undefined}
              className={cn(
                'group relative flex items-center gap-3 rounded-lg px-3 py-2 text-sm font-medium transition-colors',
                collapsed && 'justify-center',
                active
                  ? 'bg-brand-navy-800 text-white'
                  : 'text-white/70 hover:bg-white/5 hover:text-white'
              )}
            >
              {active && (
                <span className='absolute left-0 top-1/2 h-6 w-1 -translate-y-1/2 rounded-r-full bg-brand-orange' />
              )}
              <Icon
                className={cn(
                  'h-4 w-4 shrink-0',
                  active
                    ? 'text-brand-orange'
                    : 'text-white/60 group-hover:text-white'
                )}
              />
              {!collapsed && (
                <span className='flex min-w-0 flex-1 items-center gap-2'>
                  <span className='truncate'>{item.label}</span>
                  {item.comingSoon && (
                    <span className='shrink-0 rounded bg-white/10 px-1.5 py-0.5 text-[9px] font-bold uppercase tracking-wider text-white/60'>
                      Soon
                    </span>
                  )}
                </span>
              )}
            </NavLink>
          );
        })}
      </div>
    </div>
  );
};

export default MenuItems;
